import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '../../authApiService';
import { BillingFrequencyType, BillingPlanScheduleType } from '@/const/shared';

export type BillingPlanType = {
  id: string;
  name: string;
  monthly_views: number;
  max_users: number;
  billing_frequency: BillingFrequencyType;
  currency: string;
  interval_price_amount: number;
  extra_view_price_amount: number;
  schedule_type: BillingPlanScheduleType;
  recommended: boolean;
  enabled_id_verification: boolean;
  order: number;
};

export const getBillingPlanDetailsApi = (planId: string): Promise<ApiResponseType<BillingPlanType>> => {
  const uri = `/billing/plans/${planId}/`;

  return authApiService.GET(uri);
};
